module.exports = __webpack_public_path__ + "media/5.cdc6d04e.wav";